import { useState, useEffect } from 'react';
import { useInstitutionalTrading } from './useInstitutionalTrading';

export const useHedgeStrategy = (position) => {
  const [hedgeStrategy, setHedgeStrategy] = useState(null);
  const [isCalculating, setIsCalculating] = useState(false);
  const { btcPrice, strikes } = useInstitutionalTrading();

  useEffect(() => {
    if (position && btcPrice && strikes.length > 0) {
      setIsCalculating(true);
      
      setTimeout(() => {
        const atmStrike = strikes.find(s => s.call.moneyness === 'ATM');
        
        if (atmStrike) {
          const strategy = {
            strategy_name: 'Protective Put',
            description: 'Purchase put options to protect against downside risk',
            risk_level: 'Low',
            strike_price: atmStrike.price,
            cost: atmStrike.put.premium * position.size * 10,
            max_protection: (atmStrike.price - position.entry_price) * position.size,
            expiry: '2HR',
            moneyness: '0.2',
            risk_reduction: 85,
            remaining_risk: position.unrealized_pnl * 0.15
          };
          
          setHedgeStrategy(strategy);
        }
        
        setIsCalculating(false);
      }, 1500);
    }
  }, [position, btcPrice, strikes]);

  return { hedgeStrategy, isCalculating };
};
